var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNightowlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1918 14.6575C11.1918 14.6575 4.55418 12.2966 5.33888 9.07072C5.33888 9.07072 5.27504 8.2069 7.05456 5.80603C7.05456 5.80603 9.56545 6.24824 11.2116 7.13186",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1704 0.979522C11.1704 0.979522 8.32982 -0.324497 4.98695 1.84739L2.82275 1.89423L5.93934 3.59968",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2116 2.38166C12.1054 2.26939 13.1504 2.31301 14.2886 2.68454L16.5053 2.10543L13.3883 0.400391L11.1704 0.979506",
    stroke: "#83C8BC",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1915 20.5997C0.393977 14.3809 5.09614 6.92309 5.09614 6.92309L5.93903 3.59943L8.10484 3.55299C8.10484 3.55299 9.32109 2.6193 11.2113 2.38184",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2115 9.55054L9.93506 11.155L11.1917 13.171",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1917 20.5998C11.1917 20.5998 -2.46022 17.4389 1.94091 5.28995L2.82259 1.89441",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1919 20.5997V13.171L12.4558 10.815L11.2117 9.55051V2.38184",
    stroke: "#83C8BC",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83155 9.49252C6.83276 8.80356 7.35077 8.16952 7.98516 8.07946C8.62077 7.98981 9.13676 8.47806 9.13555 9.16662C9.13393 9.85639 8.61592 10.4912 7.98072 10.5809C7.34633 10.6705 6.83033 10.1823 6.83155 9.49252Z",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4883 8.26881C15.4867 8.95858 14.9699 9.59302 14.3347 9.68268C13.6991 9.77273 13.1843 9.28408 13.1855 8.59431C13.1868 7.90575 13.7036 7.27131 14.3392 7.18166C14.9748 7.0916 15.4896 7.58025 15.4883 8.26881Z",
    stroke: "#83C8BC",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.505 2.10559L17.3915 5.40259C17.3915 5.40259 21.8246 11.4857 11.1919 20.5997",
    stroke: "#83C8BC",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2063 10.1991C18.2063 10.1991 14.1814 12.3968 12.8213 19.116",
    stroke: "#83C8BC",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18945 12.2386C4.18945 12.2386 8.16631 13.3193 9.51833 19.5438",
    stroke: "#566463",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2112 7.13201C11.2112 7.13201 13.0441 5.72461 15.3586 4.6322C15.3586 4.6322 19.2061 7.65459 15.3586 11.2512C12.5374 13.8875 11.484 14.5244 11.1914 14.6577",
    stroke: "#83C8BC",
    strokeWidth: 0.504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightowlIcon);
export default __webpack_public_path__ + "static/media/nightowl-icon.1713783e779e3f29746cfb226030f350.svg";
export { ForwardRef as ReactComponent };